var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { attrs: { fluid: "", "grid-list-md": "" } },
    [
      _c(
        "v-tabs",
        { attrs: { left: "", color: "transparent" } },
        [_c("v-tab", [_vm._v("Cambios de SerTec")])],
        1
      ),
      _c("v-divider"),
      _c(
        "div",
        { staticClass: "asignacionNoSeriado" },
        [
          _c(
            "v-card",
            [
              _c(
                "div",
                {
                  staticClass: "layout row wrap",
                  staticStyle: {
                    "padding-right": "0px",
                    "padding-left": "10px"
                  }
                },
                [
                  _c(
                    "div",
                    { staticClass: "flex xs6 sm3 md2" },
                    [
                      _c("v-autocomplete", {
                        attrs: {
                          "item-text": "tipofecha_nombre",
                          items: _vm.filtro_tipo_fecha,
                          "item-value": "tipofecha_id",
                          label: "Tipo Fecha",
                          "prepend-icon": "supervisor_account"
                        },
                        model: {
                          value: _vm.model_tipo_fecha,
                          callback: function($$v) {
                            _vm.model_tipo_fecha = $$v
                          },
                          expression: "model_tipo_fecha"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "flex xs6 sm3 md2" },
                    [
                      _c("DatePicker", {
                        attrs: {
                          locale: "es-cl",
                          color: "primary",
                          label: "Fecha Inicio"
                        },
                        model: {
                          value: _vm.model_filtro_inicio,
                          callback: function($$v) {
                            _vm.model_filtro_inicio = $$v
                          },
                          expression: "model_filtro_inicio"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "flex xs6 sm3 md2" },
                    [
                      _c("DatePicker", {
                        attrs: {
                          locale: "es-cl",
                          color: "primary",
                          label: "Fecha Fin"
                        },
                        model: {
                          value: _vm.model_filtro_fin,
                          callback: function($$v) {
                            _vm.model_filtro_fin = $$v
                          },
                          expression: "model_filtro_fin"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "flex xs6 sm3 md2" },
                    [
                      _c("v-autocomplete", {
                        attrs: {
                          label: "Técnico",
                          "item-text": "tecniconame",
                          "item-value": "tecnicoid",
                          items: _vm.filtro_tecnico,
                          "prepend-icon": "speed"
                        },
                        model: {
                          value: _vm.model_filtro_tecnico,
                          callback: function($$v) {
                            _vm.model_filtro_tecnico = $$v
                          },
                          expression: "model_filtro_tecnico"
                        }
                      })
                    ],
                    1
                  ),
                  _c("div", { staticClass: "flex xs6 sm3 md2" }, [
                    _c(
                      "div",
                      { staticClass: "text-sm-center botones-filtros" },
                      [
                        _c(
                          "v-btn",
                          { on: { click: _vm.applyfilters } },
                          [_c("v-icon", [_vm._v("search")]), _vm._v("Filtrar")],
                          1
                        )
                      ],
                      1
                    )
                  ])
                ]
              ),
              _c(
                "div",
                {
                  staticClass: "layout row wrap",
                  staticStyle: {
                    "padding-right": "0px",
                    "padding-left": "10px"
                  }
                },
                [
                  _c(
                    "div",
                    { staticClass: "flex xs6 sm3 md2" },
                    [
                      _c("v-autocomplete", {
                        attrs: {
                          label: "Equipo",
                          "item-text": "tipoeqname",
                          "item-value": "tipoeqid",
                          items: _vm.filtro_equipo,
                          "prepend-icon": "home_repair_service"
                        },
                        model: {
                          value: _vm.model_filtro_equipo,
                          callback: function($$v) {
                            _vm.model_filtro_equipo = $$v
                          },
                          expression: "model_filtro_equipo"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "flex xs6 sm3 md2" },
                    [
                      _c("v-autocomplete", {
                        attrs: {
                          label: "Clientes",
                          "item-text": "nombre",
                          "item-value": "id",
                          items: _vm.filtro_cliente,
                          "prepend-icon": "account_circle"
                        },
                        model: {
                          value: _vm.model_filtro_cliente,
                          callback: function($$v) {
                            _vm.model_filtro_cliente = $$v
                          },
                          expression: "model_filtro_cliente"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "flex xs6 sm3 md2" },
                    [
                      _c("v-autocomplete", {
                        attrs: {
                          label: "Referencias",
                          "item-text": "cambiosernumero",
                          "item-value": "cambiosernumero",
                          items: _vm.filtro_referencias,
                          "prepend-icon": "account_circle"
                        },
                        model: {
                          value: _vm.model_referencias,
                          callback: function($$v) {
                            _vm.model_referencias = $$v
                          },
                          expression: "model_referencias"
                        }
                      })
                    ],
                    1
                  ),
                  _c("div", { staticClass: "flex xs6 sm3 md2" }),
                  _c("div", { staticClass: "flex xs6 sm3 md2" }, [
                    _c(
                      "div",
                      { staticClass: "text-sm-center botones-filtros" },
                      [
                        _c(
                          "v-btn",
                          { on: { click: _vm.cleanfilters } },
                          [_c("v-icon", [_vm._v("clear")]), _vm._v("Limpiar")],
                          1
                        )
                      ],
                      1
                    )
                  ])
                ]
              ),
              _c(
                "div",
                {
                  staticClass: "layout row wrap",
                  staticStyle: {
                    "padding-right": "0px",
                    "padding-left": "10px"
                  }
                },
                [
                  _c("div", {
                    staticClass: "flex xs12 sm6 md6",
                    attrs: { align: "lef" }
                  }),
                  _c("div", {
                    staticClass: "flex xs12 sm6 md6",
                    attrs: { align: "right" }
                  })
                ]
              ),
              _c(
                "div",
                {
                  staticClass: "layout row wrap",
                  staticStyle: {
                    "padding-right": "0px",
                    "padding-left": "10px"
                  }
                },
                [
                  _c("div", {
                    staticClass: "flex xs12 sm6 md6",
                    attrs: { align: "lef" }
                  }),
                  _c(
                    "div",
                    {
                      staticClass: "flex xs12 sm6 md6",
                      attrs: { align: "right" }
                    },
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: { flat: "", small: "", color: "primary" },
                          on: { click: _vm.btn_exportar }
                        },
                        [
                          _c("v-icon", { staticClass: "importExportBtnIcon" }, [
                            _vm._v("cloud_download")
                          ]),
                          _vm._v("  \n            "),
                          _c("span", { staticClass: "importExportBtnTexto" }, [
                            _vm._v("Exportar csv")
                          ])
                        ],
                        1
                      ),
                      _c(
                        "v-btn",
                        {
                          staticClass: "btn-crear v-btn theme--light",
                          on: { click: _vm.handlerbuttonmodal }
                        },
                        [
                          _c(
                            "i",
                            {
                              staticClass:
                                "v-icon v-icon--left material-icons theme--dark",
                              staticStyle: { color: "black" },
                              attrs: { "aria-hidden": "true" }
                            },
                            [_vm._v("add_circle_outline")]
                          ),
                          _c("span", [_vm._v("Crear")])
                        ]
                      )
                    ],
                    1
                  )
                ]
              ),
              _c(
                "div",
                { staticClass: "gridcard rounded-card" },
                [
                  _c("MantenedorGridSinCodigo", {
                    attrs: {
                      "grid-options": _vm.gridOptions,
                      "funcionalidad-id": _vm.funcionalidad
                    }
                  })
                ],
                1
              ),
              _vm.ModalState
                ? _c("modalverdetalleCS", {
                    attrs: {
                      show: _vm.ModalState,
                      id_cs: _vm.cs_seleccionada,
                      accion_modal: _vm.accion_modal,
                      estado: _vm.estado
                    },
                    on: {
                      modalOrdenCompraEmit: function($event) {
                        return _vm.modalOCCallback($event)
                      }
                    }
                  })
                : _vm._e(),
              _vm.showReporteGenerado
                ? _c("div", { staticClass: "wrap-evidencia" }, [
                    _c(
                      "div",
                      { staticClass: "modalEnvio", attrs: { id: "myModal2" } },
                      [
                        _c("div", { staticClass: "modalEnvio-content" }, [
                          _c(
                            "div",
                            [
                              _c("div", { staticClass: "titleEvidencia" }, [
                                _c(
                                  "h2",
                                  { staticClass: "importExportBtnIcon" },
                                  [_vm._v("Reporte Solicitado")]
                                )
                              ]),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "buttonClose buttonCloseEvidencia",
                                  attrs: { align: "right" }
                                },
                                [
                                  _c(
                                    "v-btn",
                                    {
                                      attrs: {
                                        flat: "",
                                        small: "",
                                        color: "primary"
                                      },
                                      on: {
                                        click: function($event) {
                                          return _vm.closeReporte()
                                        }
                                      }
                                    },
                                    [
                                      _c(
                                        "v-icon",
                                        { staticClass: "importExportBtnIcon" },
                                        [_vm._v("close")]
                                      ),
                                      _vm._v("  \n                  "),
                                      _c(
                                        "span",
                                        { staticClass: "importExportBtnTexto" },
                                        [_vm._v("Cerrar")]
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c("v-flex", { attrs: { sm12: "", md12: "" } }, [
                                _c("div", { staticClass: "text-sm-center" }, [
                                  _c(
                                    "p",
                                    { staticStyle: { "margin-top": "40px" } },
                                    [_vm._v(_vm._s(_vm.texto_reporte))]
                                  )
                                ]),
                                _c("div", { staticClass: "text-sm-center" }, [
                                  _c(
                                    "p",
                                    { staticStyle: { "margin-top": "40px" } },
                                    [
                                      _vm._v(
                                        "\n                    Puede ver sus reportes en el menú\n                    "
                                      ),
                                      _c(
                                        "router-link",
                                        {
                                          staticStyle: {
                                            cursor: "pointer",
                                            "font-size": "13px"
                                          },
                                          attrs: {
                                            "active-class":
                                              "router-link-active",
                                            to: "/conecta-reportes"
                                          }
                                        },
                                        [_vm._v("Informes")]
                                      )
                                    ],
                                    1
                                  )
                                ])
                              ])
                            ],
                            1
                          )
                        ])
                      ]
                    )
                  ])
                : _vm._e()
            ],
            1
          ),
          _c("app-confirmacion", {
            attrs: {
              show: _vm.dialogConfirmacion,
              nombre: _vm.nombre,
              titulo: "Anular la Solicitud No. " + _vm.nombre,
              mensaje: _vm.$t(
                "Despúes de realizada la acción no se podrá reversar."
              ),
              textoBtnSi: _vm.$t("mensajes.crud.crear.btnAceptar"),
              textoBtnNo: _vm.$t("mensajes.crud.crear.btnCancelar")
            },
            on: {
              modalConfirmationEmit: function($event) {
                return _vm.confirmCallback($event)
              }
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }